import { NodeAspect } from './node-aspect';
import { Item } from "../data/entities/entities";
export class ListBoxItem extends Item {
    nodeAspect: NodeAspect;
}